/**
 * Render a Svelte component to a target element.
 * @param {typeof import('svelte').SvelteComponent} Component
 * @param {HTMLElement} target
 * @param {Record<string, any>} props
 * @param {boolean} hydrate
 * @param {import('svelte').Component}
 */
export function renderSvelteComponent(
  Component,
  target,
  props = {},
  hydrate = false
) {
  return new Component({ target, props, hydrate });
}

/**
 *
 * @param {string} selector
 * @returns {Element|undefined}
 */

export function findSvelteComponentContainer(selector) {
  const elementById = document.querySelector(selector);
  if (elementById) return elementById;

  // Check for Baker embeds
  for (const element of Array.from(
    document.querySelectorAll('ps-baker-webcomponent-module')
  )) {
    const match = element.shadowRoot?.querySelector(selector);
    if (match) {
      return match;
    }
  }
}

export function findSvelteComponentContainers(selector) {
  const elementsById = document.querySelectorAll(selector);
  if (elementsById.length) return elementsById;

  // Check for Baker embeds
  let matches = [];
  for (const element of Array.from(
    document.querySelectorAll('ps-baker-webcomponent-module')
  )) {
    const match = element.shadowRoot?.querySelector(selector);
    if (match) {
      matches.push(match);
    }
  }
  return matches;
}
